import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import {
    ContainerListProduct,
    BoxTituloPagina,
    ContainerProdutos,
    BoxProdutosFiltro1,
    BoxProdutosFiltro,
    BoxCardsProdutos,
    TituloP,
    DescricaoP,
    OrdenadoP,
    OrdenP,
    FiltroSelecionado,
    TituloFiltro,
    ApagarTudo,
    FiltroSP,
    NomeProdutoP,
    CardProdutoList,
    ValorInicialP,
    ValorNovoP,
    BoxProductInfo,
    BoxInfoClassific,
    BoxValoresProduct,
    BoxSelecaoFiltro,
    RemoverFiltro,
    BoxEscolherFiltro,
    BoxCheckFiltro,
    CheckFiltro,
    ImgProduto,
    ContainerBoxProdutos,
    PReviews,
    BoxCardsProdutosMobile
} from '../Product.style.js';
import {
    ProductCardStatus,
    NovoProduto,
    NovoProdutoP,
    Desconto,
    DescontoP
} from '../Home.style.js';
import SetaBaixo from '../../components/svg/setaBaixo.svg';
import API from '../../examples/modelo_api_product.json';
import axios from "axios";
import apiService from "../../api/home.js";

function Produto() {

    const [DadosAPI, setDadosAPI] = useState(API);
    const [simbolo, setSimbolo] = useState(false);

    const titulopagina = DadosAPI.dados.productheader[0].title;
    const descricaopagina = DadosAPI.dados.productheader[0].descricao;

    var dominioAtual = apiService.obterDominio()

    useEffect(() => {
        listarProdutos();
    }, [])

    const [produtosAPI, setProdutosAPI] = useState([])

    const listarProdutos = async () => {

        const getAmbiente = apiService.ambiente();
        var getDominio = apiService.obterDominio()

        const url = new URLSearchParams(window.location.search);
        const params = url.get('categoria');

        try {
            const response = await axios.post(
                getAmbiente + '/integracao/site/produtos',
                {
                    dominio: getDominio,
                    idcategoriasite: `${params ? params : ""}`
                }
            );

            if (response.data.retorno == null || response.data.retorno == []) {
                console.log("Produto vazio")
                return false
            }

            const produtos = response.data.retorno.produtos.map((i) => {
                const precoNumerico = parseFloat(i.preco.replace(',', '.')); // Converte preço para número
                return { ...i, preco: precoNumerico };
            });

            setProdutosAPI(produtos)
        } catch (error) {
            console.error('Erro ao listar produtos:', error);
        }
    };

    function renderImg(imgPrincipal, fotos) {

        const getAmbiente = apiService.ambiente();

        // nao existe foto princiapl usa  a foto secundaria
        if (imgPrincipal == null) {

            if (fotos && fotos.length > 0) {
                imgPrincipal = fotos[0].urlfoto
            }

        }

        var get_item_url = imgPrincipal;
        var url = getAmbiente + "/" + get_item_url



        return url;
    }

    const ordenar = () => {
        if (simbolo) {
            setSimbolo(!simbolo)
            // Ordenar por menor preço
            const produtosOrdenadosPorPrecoAsc = [...produtosAPI].sort((a, b) => a.preco - b.preco);
            setProdutosAPI(produtosOrdenadosPorPrecoAsc);
        } else {
            setSimbolo(!simbolo)
            // Ordenar por maior preço
            const produtosOrdenadosPorPrecoDesc = [...produtosAPI].sort((a, b) => b.preco - a.preco);
            setProdutosAPI(produtosOrdenadosPorPrecoDesc);
        }
    }

    const formatCurrency = (value) => {
        // Verifica se o valor é nulo ou indefinido
        if (value == null) {
            return 'R$ 0,00'; // Retorna um valor padrão
        }

        // Converte o valor em uma string, remove caracteres não numéricos e tenta convertê-lo em um número
        const numericValue = parseFloat(String(value).replace(/[^\d.-]/g, ''));

        // Verifica se o valor é um número válido
        if (!isNaN(numericValue)) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(numericValue);
        } else {
            // Retorna o valor original se não for um número válido
            return String(value);
        }
    };

    return (
        <ContainerListProduct>
            <BoxTituloPagina>
                <div>
                    <TituloP>{titulopagina}</TituloP>
                    {dominioAtual === 'rpjoiasesemijoias' && descricaopagina && (
                        <DescricaoP>{descricaopagina}</DescricaoP>
                    )}
                </div>
                <div style={{ margin: '5px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <OrdenadoP>Ordenar por</OrdenadoP>
                    <div onClick={() => ordenar()} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        <OrdenP>{!simbolo ? 'maior preço' : 'menor preço'}</OrdenP>
                        <img src={SetaBaixo} />
                    </div>
                </div>
            </BoxTituloPagina>

            <ContainerProdutos>
                {/* <BoxProdutosFiltro1>
                    <BoxSelecaoFiltro>
                        <FiltroSelecionado>
                            <p style={{ margin: '0px', fontSize: '12px', marginRight: '5px' }}>x</p><FiltroSP> Filtro selecionado</FiltroSP>
                        </FiltroSelecionado>
                        <RemoverFiltro>
                            <ApagarTudo>Apagar todos</ApagarTudo>
                        </RemoverFiltro>
                    </BoxSelecaoFiltro>

                    {categoriafiltro.map((section) => (
                        <BoxEscolherFiltro key={section.id}>
                            <TituloFiltro>{section.title}</TituloFiltro>
                            <BoxCheckFiltro>
                                {section.categoria.map((item) => (
                                    <CheckFiltro key={item.id}>
                                        <input type="checkbox" id={item.title} name={item.title} />
                                        <label htmlFor={item.title}>{item.title}</label>
                                        <div>(10)</div>
                                    </CheckFiltro>
                                ))}
                                <div><p style={{ cursor: 'pointer' }}>ver mais</p></div>
                            </BoxCheckFiltro>
                        </BoxEscolherFiltro>
                    ))}
                </BoxProdutosFiltro1> */}

                <BoxProdutosFiltro>
                    <BoxCardsProdutos>
                        {produtosAPI.map((section) => (
                            <ContainerBoxProdutos key={section.id}>
                                <Link style={{ textDecoration: 'none', color: 'black' }} to={`${section.urlproduto}`}>
                                    <CardProdutoList>
                                        <ImgProduto>
                                            {/* <img style={{ width: '100%', height: '100%', borderRadius: 20 }} src={section.foto}></img> */}
                                            <img style={{ width: '100%', height: '100%', borderRadius: 20, objectFit: 'cover', }} src={renderImg(section.urlfotoprincipal, section.fotos)}></img>
                                            {/* <ProductCardStatus>
                                                <NovoProduto>
                                                    <NovoProdutoP>Novo produto</NovoProdutoP>
                                                </NovoProduto>
                                                <Desconto>
                                                    <DescontoP>56% OFF</DescontoP>
                                                </Desconto>
                                            </ProductCardStatus> */}
                                        </ImgProduto>
                                        <BoxProductInfo>
                                            <NomeProdutoP>{section.tituloloja}</NomeProdutoP>
                                            <BoxInfoClassific>
                                                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <PReviews style={{ marginLeft: '5px', margin: '0' }}>{section.avaliacao}</PReviews>
                                                </div> */}
                                                {/* <div style={{ marginLeft: '20px' }}>
                                                    <PReviews style={{ margin: '0' }}>{section.reviews}</PReviews>
                                                </div> */}
                                            </BoxInfoClassific>
                                            <BoxValoresProduct>
                                                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <ValorInicialP style={{ margin: '0' }}>{section.precopromocionalloja}</ValorInicialP>
                                                </div> */}
                                                <div >
                                                    <ValorNovoP style={{ margin: '0' }}>{formatCurrency(section.preco)}</ValorNovoP>
                                                </div>
                                            </BoxValoresProduct>
                                        </BoxProductInfo>
                                    </CardProdutoList>
                                </Link>
                            </ContainerBoxProdutos>
                        ))}
                    </BoxCardsProdutos>
                </BoxProdutosFiltro>
            </ContainerProdutos>
        </ContainerListProduct>
    );
}

export default Produto;
